import { formatApiErrorMessage } from "@/services/_apiConfig";

/**
 * Uploads each file independently so one failure doesn't stop the rest.
 * `uploadOne(file)` should resolve to the API response (`{ success: false, error }` on failure).
 * Returns `[{ name, message }]` for the files that failed.
 */
export async function uploadEachFile(files, uploadOne) {
  const failures = [];
  for (const file of files) {
    try {
      const res = await uploadOne(file);
      if (res?.success === false) {
        failures.push({ name: file.name, message: formatApiErrorMessage(res.error, "Upload failed") });
      }
    } catch (err) {
      failures.push({ name: file.name, message: err?.message || "Upload failed" });
    }
  }
  return failures;
}

/** Customer-facing summary of failed uploads, or "" when none failed. */
export function describeUploadFailures(failures, totalCount) {
  if (!failures.length) return "";
  const details = failures.map((f) => `"${f.name}": ${f.message}`).join("; ");
  if (totalCount > 1) {
    return `${failures.length} of ${totalCount} files could not be uploaded. ${details}`;
  }
  return `Could not upload ${details}`;
}
